import { richTextLength } from "@mylaunch/payload/richText"
import { RichText } from "~/components/ui/rich-text"
import { Link } from "@tanstack/react-router"
import { AttachmentList } from "~/components/ui/attachment-list"
import { Media } from "~/components/ui/media"
import type { Post } from "@apps/gwservice/types"
import { EngagementRow } from "~/components/post/engagement-row"
import { PostMeta } from "~/components/post/post-meta"

interface PostCardProps {
  post: Post
}

const previewClampLen = 300

export function PostCard({ post }: PostCardProps) {
  const previewLen = post.preview ? richTextLength(post.preview) : 0
  const showReadMore = post.hasText || previewLen > previewClampLen

  return (
    <div className="bg-white rounded-xl shadow-sm flex flex-col">
      <PostMeta post={post} group={post.group} author={post.author} date={post.publishedAt ?? post.createdAt} linkToPost />

      <div className="flex flex-col gap-s">
        {post.cover && (
          <Media
            url={post.cover.url}
            mimeType={post.cover.mimeType}
            posterUrl={post.cover.poster?.url}
            alt={post.title ?? ""}
            className="w-full"
          />
        )}

        <Link to={"/post/" + post.id} className="flex flex-col gap-s">
          {post.title && <h3 className="px-m text-lg font-bold leading-tight">{post.title}</h3>}
          <Preview preview={post.preview} />
        </Link>

        {showReadMore && (
          <Link to={"/post/" + post.id} className="px-m text-primary font-medium">
            Читать далее...
          </Link>
        )}
      </div>
      <AttachmentList attachments={post.attachments} className="mt-s" />
      <Link to={"/post/" + post.id}>
        <EngagementRow postId={post.id} views={post.views} likes={post.likes} comments={post.comments} likedByMe={post.likedByMe} />
      </Link>
    </div>
  )
}

const Preview = ({ preview }: { preview: Post["preview"] }) => {
  if (!preview) return null
  return (
    <RichText
      data={preview}
      className="px-m leading-relaxed font-semibold line-clamp-6 [&_a]:underline [&_p+p]:mt-s [&_p+ul]:mt-s [&_ul+p]:mt-s [&_ul]:list-disc [&_ul]:pl-m [&_li]:ml-s"
    />
  )
}
